<form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
  <lib-ui-agency-form formControlName="agency" [states]="states()" [programs]="programs()"> </lib-ui-agency-form>
  <lib-button
    [cssType]="'btn-primary'"
    [icon]="'rightarrow'"
    [text]="'Update Company'"
    [size]="'large'"
    [type]="'submit'"
  ></lib-button>
</form>
